import React from "react";
import PropTypes from "prop-types";
import { Form } from "../../../../primary";
import { FormActions } from "../../../../secondary";
import { getControl } from "../../../../common/ConfigForm/fieldRegistry";
import { CREATE_CUSTOMER_FIELDS, CREATE_CUSTOMER_ROWS, BASIC_INFO_CUSTOM_VALIDATORS } from "../basicInfo.config";
import { useCreateCustomerModal } from "../hooks/useCreateCustomerModal";
import { CANCEL_BTN, SAVE_BTN } from "../../../../../constants";
import { PERMISSIONS } from "../../../../../constants/permissions";
import formStyle from "../../../../common/ConfigForm/ConfigForm.module.scss";
import styles from "./CreateCustomerModal.module.scss";

const FIELDS_BY_KEY = CREATE_CUSTOMER_FIELDS.reduce((map, field) => ({ ...map, [field.key]: field }), {});

const cx = (...classNames) => classNames.filter(Boolean).join(" ");

const renderField = (key, ctx) => {
  const field = FIELDS_BY_KEY[key];
  const entry = getControl(field.control);
  if (!entry) return null;
  const { Component, mapProps } = entry;

  return (
    <div className={styles.field} key={key}>
      {field.label && (
        <label className={formStyle.form_field_label} htmlFor={field.key}>
          {field.label}:{field.required && <span className={formStyle.form_astrick}>&#42;</span>}
        </label>
      )}
      <div className={formStyle.form_field_control}>
        <Component {...mapProps({ field, ...ctx })} />
      </div>
    </div>
  );
};

export const CreateCustomerModal = ({ onCancel }) => {
  const hook = useCreateCustomerModal();

  const ctx = {
    form: hook.form,
    errors: hook.errors,
    onFieldChange: hook.onFieldChange,
    register: hook.register,
    customValidators: BASIC_INFO_CUSTOM_VALIDATORS,
    extra: hook.extra,
  };

  return (
    <div className={`${formStyle.form_container} m-4`}>
      <Form onSubmit={hook.handleSubmit(hook.doSubmit)} requiredPermission={PERMISSIONS.ADMIN_CUSTOMERS}>
        <section className={formStyle.form_section}>
          <div className={formStyle.form_section_header}>
            <span className={formStyle.form_section_title}>General Data</span>
          </div>
          <div className={formStyle.form_section_body}>
            {CREATE_CUSTOMER_ROWS.map((rowKeys) => (
              <div className={cx(styles.field_row, styles[`field_row_${rowKeys.length}`])} key={rowKeys.join("-")}>
                {rowKeys.map((key) => renderField(key, ctx))}
              </div>
            ))}
          </div>
        </section>

        <FormActions
          primaryLabel={SAVE_BTN}
          primaryId="createCustomerSubmitBtn"
          primaryType="submit"
          primaryLoading={hook.saveLoading}
          secondaryLabel={CANCEL_BTN}
          secondaryId="createCustomerCancelBtn"
          secondaryDisabled={hook.saveLoading}
          onSecondaryClick={onCancel}
        />
      </Form>
    </div>
  );
};

CreateCustomerModal.propTypes = {
  onCancel: PropTypes.func,
};
